import { LocationType } from '../Sidebar/LocationList';

// Map style and default location
export const MAPBOX_STYLE = 'mapbox://styles/mapbox/streets-v11';
export const MELBOURNE_COORDINATES = { lng: 144.9631, lat: -37.8136 };

// Marker color configuration
export const MARKER_COLORS = {
  [LocationType.NORMAL]: '#3498db',   // Normal point - Blue
  [LocationType.START]: '#2ecc71',    // Supply point - Green
  [LocationType.END]: '#e74c3c',      // End point - Red
  [LocationType.WAYPOINT]: '#3498db'  // Demand point - Blue
};

// Layer ID constants
export const POINTS_SOURCE = 'points-source';
export const POINTS_CIRCLE_LAYER = 'points-circle-layer';
export const POINTS_SYMBOL_LAYER = 'points-symbol-layer';
export const AUTO_PATH_SOURCE = 'auto-path-source';
export const AUTO_PATH_LAYER = 'auto-path-layer';
export const CUSTOM_PATH_SOURCE = 'custom-path-source';
export const CUSTOM_PATH_LAYER = 'custom-path-layer';
export const DISTANCE_LABELS_SOURCE = 'distance-labels-source';
export const DISTANCE_LABELS_LAYER = 'distance-labels-layer';

// Path line styles
export const PATH_STYLES = {
  auto: {
    color: '#2196F3', // Blue
    width: 4,         // Thicker
    opacity: 0.8
  },
  custom: {
    color: '#FF5722', // Orange-red
    width: 3,         // Slightly thinner
    opacity: 0.7
  }
};

// Distance labels configuration
export const CITY_ZOOM_THRESHOLD = 8; // Zoom level below which distance labels are auto-hidden 